import * as doctorInfo from "../constants/index";
import { timeslotProps, stateProps } from "../types/doctorInfo.types";

export const next = () => {
  return {
    type: doctorInfo.nextButton,
  };
};

export const back = () => {
  return {
    type: doctorInfo.backButton,
  };
};

export const enterEmail = (email: string, isEmptyAndValidEmail: boolean) => {
  return {
    type: doctorInfo.enterEmail,
    email: email,
    isEmptyAndValidEmail: isEmptyAndValidEmail,
  };
};

export const enterFirstName = (firstName: string) => {
  return {
    type: doctorInfo.enterFirstName,
    firstName: firstName,
  };
};

export const enterLastName = (lastName: string) => {
  return {
    type: doctorInfo.enterLastName,
    lastName: lastName,
  };
};

export const enterDegree = (degree: string) => {
  return {
    type: doctorInfo.enterDegree,
    degree: degree,
  };
};

export const enterRegiNumber = (regiNumber: number) => {
  return {
    type: doctorInfo.enterRegiNumber,
    regiNumber: regiNumber,
  };
};

export const enterQualifications = (qualifications: string) => {
  return {
    type: doctorInfo.enterQualifications,
    qualifications: qualifications,
  };
};

export const changeCustomSpeciality = (customSpeciality: string) => {
  return {
    type: doctorInfo.changeCustomSpeciality,
    customSpeciality: customSpeciality,
  };
};

export const changeSpeciality = (speciality: { id?: number; name?: string }) => {
  return {
    type: doctorInfo.changeSpeciality,
    speciality: speciality,
  };
};

export const enterPractising = (practising: string) => {
  return {
    type: doctorInfo.enterPractising,
    practising: practising,
  };
};

export const enterBankName = (bankName: string) => {
  return {
    type: doctorInfo.enterBankName,
    bankName: bankName,
  };
};

export const enterBranchName = (branchName: string) => {
  return {
    type: doctorInfo.enterBranchName,
    branchName: branchName,
  };
};

export const enterAcntHolderName = (acntHolder: string) => {
  return {
    type: doctorInfo.enterAcntHolderName,
    acntHolder: acntHolder,
  };
};

export const enterAcntNumber = (acntNumber: number) => {
  return {
    type: doctorInfo.enterAcntNumber,
    acntNumber: acntNumber,
  };
};

export const changeTitle = (title: string) => {
  return {
    type: doctorInfo.changeTitle,
    title: title,
  };
};

export const changeGender = (gender: string) => {
  return {
    type: doctorInfo.changeGender,
    gender: gender,
  };
};

export const changeLanguage = (languages: { id: number; name: string; status?: boolean }[]) => {
  return {
    type: doctorInfo.changeLanguage,
    languages: languages,
  };
};

export const changeTimeSlots = (timeslot: timeslotProps[]) => {
  return {
    type: doctorInfo.changeTimeSlot,
    timeslot: timeslot,
  };
};

export const changeBoardCertified = (boardCertified: string) => {
  return {
    type: doctorInfo.changeBoardCertified,
    boardCertified: boardCertified,
  };
};

export const changeTermsAndConditions = (termsAndConditions: string) => {
  return {
    type: doctorInfo.changeTermsAndConditions,
    termsAndConditions: termsAndConditions,
  };
};

export const changePrice = (value: string | undefined) => {
  return {
    type: doctorInfo.changePrice,
    price: value === undefined ? "" : value,
  };
};

export const changeCurrency = (pcurrency: string) => {
  return {
    type: doctorInfo.changeCurrency,
    pcurrency: pcurrency,
  };
};

export const changePhoneNumber = (phone: string) => {
  return {
    type: doctorInfo.changePhoneNumber,
    phone: phone,
  };
};
export const changeSignatureImage = (signatureImage: string) => {
  return {
    type: doctorInfo.changeSignatureImage,
    signatureImage: signatureImage,
  };
};

export const changeProfileImage = (profileImage: string) => {
  return {
    type: doctorInfo.changeProfileImage,
    profileImage: profileImage,
  };
};

export const changeNICImage = (nicImage: string) => {
  return {
    type: doctorInfo.changeNICImage,
    nicImage: nicImage,
  };
};

export const changeSealImage = (sealImage: string) => {
  return {
    type: doctorInfo.changeSealImage,
    sealImage: sealImage,
  };
};

export const changeSLMCCertificateImage = (slmcCertificateImage: string) => {
  return {
    type: doctorInfo.changeSLMCCertificateImage,
    slmcCertificateImage: slmcCertificateImage,
  };
};

export const changeSLMCIDImage = (slmcIDImage: string) => {
  return {
    type: doctorInfo.changeSLMCIDImage,
    slmcIDImage: slmcIDImage,
  };
};

export const changeProofOfQualificationImage = (proofOfQualificationImage: string) => {
  return {
    type: doctorInfo.changeProofOfQualificationImage,
    proofOfQualificationImage: proofOfQualificationImage,
  };
};

export const submitDoctorForm = (doctorDetails: stateProps) => {
  return {
    type: doctorInfo.submitForm,
    doctorDetails: doctorDetails,
  };
};

export const getLanguages = () => {
  return {
    type: doctorInfo.getLanguages,
  };
};

export const getSpecialities = () => {
  return {
    type: doctorInfo.getSpecialities,
  };
};

export const onChangeErrorStatus = (status: boolean, msg: string) => {
  return {
    type: doctorInfo.setStatusError,
    errorData: {
      status: status,
      msg: msg,
    },
  };
};

export const onChangeErrorStatusSubmit = (status: boolean, msg: string) => {
  return {
    type: doctorInfo.setStatusErrorSubmit,
    errorDataSubmit: {
      status: status,
      msg: msg,
    },
  };
};
